// Auto-dismisses a flash toast after a few seconds so users don't have to click
// the X on every one (#330). Reuses the element's own phx-click JS (the same
// "lv:clear-flash" + hide the manual X triggers), so dismissal behaves
// identically whether it's automatic or manual.
//
// The timer pauses while the pointer is over the toast or it has keyboard focus,
// so a user reading or interacting with it won't have it vanish mid-read. Only
// attached to app-generated flashes. Connection status is managed separately
// by app.js and the compact global connection pill.
const DISMISS_MS = 5000

export default {
  mounted() {
    this.startTimer()

    this.pause = () => this.clearTimer()
    this.resume = () => this.startTimer()

    this.el.addEventListener("mouseenter", this.pause)
    this.el.addEventListener("mouseleave", this.resume)
    this.el.addEventListener("focusin", this.pause)
    this.el.addEventListener("focusout", this.resume)
  },

  destroyed() {
    this.clearTimer()
  },

  startTimer() {
    this.clearTimer()
    this.timer = setTimeout(() => {
      const js = this.el.getAttribute("phx-click")
      if (js) this.liveSocket.execJS(this.el, js)
    }, DISMISS_MS)
  },

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
